<style lang="scss">
.add-basic-details {
  .detail-item {
    display: flex;
    justify-content: space-between;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <section class="add-basic-details" v-if="person">
    <p cy="add-name" class="detail-item sm-row-drop mb-0">
      Name: <b>{{person.firstname}} {{person.lastname}}</b>
    </p>
    <!-- Hide from HMPPS prisons -->
    <p cy="add-email" class="detail-item sm-row-drop mb-0" v-if="person.email && prison.group_id !== '21a4a4957bfd41c1836ac1d127581975'">
      Email: <b>{{person.email}}</b>
    </p>
    <!-- Hide from HMPPS prisons -->
    <p cy="add-phone" class="detail-item sm-row-drop mb-0" v-if="person.phone_number && prison.group_id !== '21a4a4957bfd41c1836ac1d127581975'">
      Phone: <b>{{person.phone_number}}</b>
    </p>
    <p cy="add-dob" class="detail-item sm-row-drop mb-0">
      DOB: <b>{{person.birthDateAndAge}}
      <span v-if="person.under18 && !person.safeguarded_at_prison" class="badge badge-danger badge-pill">UNDER 18</span>
      <span v-else-if="person.under18 && person.safeguarded_at_prison" class="badge badge-success badge-pill">UNDER 18</span>

    </b>
      </p>
    <p class="detail-item sm-row-drop mb-0" cy="add-safeguarding"
      v-if="person.under18 && safeguardingStatus"
    >
      Safeguarding Status: <b>{{safeguardingStatusText()}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="add-address-1">
      Address 1: <b>{{person.address.address1 || '-'}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="add-address-2">
      Address 2: <b>{{person.address.address2 || '-'}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="add-address-3">
      Address 3: <b>{{person.address.address3 || '-'}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="add-country">
      Country: <b>{{person.address.country || '-'}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="add-region">
      Region: <b>{{person.address.region || '-'}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="add-city">
      City / Town: <b>{{person.address.city_town || '-'}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="add-postcode">
      Zip / Postal Code: <b>{{person.address.zip_postal_code || '-'}}</b>
    </p>
  </section>
</template>
<!-- eslint-enable -->

<script>
  import {mapState} from 'vuex';
  import moment from 'moment';

  export default {
    components: {},
    props: {
      person: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        test: '',
      };
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
        prison: state => state.prison.prison,
        call: state => state.callDetails.call,
        safeguardingStatus: state => state.participants.safeguardingStatus,
      }),
    },
    mounted() {

    },
    methods: {
      safeguardingStatusText() {
        if(this.safeguardingStatus) {
          const status = this.safeguardingStatus.status ? 'Completed' : 'Revoked';
          return `${status} by ${this.safeguardingStatus.prison_officer_name} on ${moment(this.safeguardingStatus.created_at).format('DD/MM/YYYY')}`;
        }
        return 'Incomplete';
      },
    },
  };
</script>
